import { Box, Container, Text } from '@chakra-ui/react';
import { disclaimer } from '../data/site';
export function Disclaimer() {
  return <Box as="aside" aria-label="Website disclaimer" bg="white" borderTop="1px solid" borderColor="navy.100" data-id="element-64" data-mp="3culltp8x46xi">
      <Container maxW="1200px" px={{
      base: 6,
      md: 8
    }} py={{
      base: 8,
      md: 10
    }} data-id="element-65" data-mp="2xxl48ekfxscr">
        <Box borderLeft="2px solid" borderColor="navy.200" pl={5} maxW="900px" data-id="element-66" data-mp="32ul427qp5yvf">
          <Text fontSize="sm" color="navy.500" lineHeight={1.8} data-id="element-67" data-mp="3qkfcmd3zh19v">
            {disclaimer}
          </Text>
        </Box>
      </Container>
    </Box>;
}